// extracted by mini-css-extract-plugin
module.exports = {"img":"colophon-module--img--3Uaxh","list":"colophon-module--list--3je0D"};